import { AuthContext } from '@repo-level/core-front';
import { ConfigContext } from 'contexts/config';
import { someGroupMember, USER_GROUP } from 'helpers/user';
import { useContext, useMemo } from 'react';

export const useUserCanAccessQuestPromo = () => {
  const { user, isAuthenticated, pendingUser } = useContext(AuthContext);
  const { isQuestDateValid } = useContext(ConfigContext);

  const hasQuestAccess = useMemo(() => {
    if (pendingUser || !isAuthenticated) return true;
    return !someGroupMember([USER_GROUP.BR, USER_GROUP.BA, USER_GROUP.VIPBA])(
      user
    );
  }, [user, isAuthenticated, pendingUser]);

  return isQuestDateValid && hasQuestAccess;
};
